import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { CARD_SIDE } from '../../../../../constants';
import { getDefaultCardSideIds } from '../../../helpers';
import CardSidePreview from '../../CardSidePreview';

const propTypes = {
  cardGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
    cards: PropTypes.shape({
      total: PropTypes.number,
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          card_side_groups: PropTypes.shape({
            total: PropTypes.number,
            records: PropTypes.array.isRequired,
          }).isRequired,
        }).isRequired,
      ).isRequired,
    }).isRequired,
  }).isRequired,
  onCardSelect: PropTypes.func.isRequired,
  loadingCard: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};

const CardGroupCardSelect = ({ cardGroup, onCardSelect, loadingCard }) => {
  const cards = cardGroup.cards.records;

  return (
    <Fragment>
      {cards.map(card => {
        const defaultCardSideIds = getDefaultCardSideIds(card);
        const cardSideGroupFront = card.card_side_groups.records.find(
          x => x.side === CARD_SIDE.FRONT,
        );

        if (!cardSideGroupFront) {
          return null;
        }

        const [cardSideFront] = cardSideGroupFront.card_sides.records;

        return (
          <CardSidePreview
            key={cardSideFront.id}
            cardSide={{
              ...cardSideFront,
              asset_image:
                cardSideFront.asset_image || cardSideGroupFront.asset_image,
            }}
            onClick={() => {
              onCardSelect({
                card_id: card.id,
                front_card_side_id: defaultCardSideIds.front_card_side_id,
                back_card_side_id: defaultCardSideIds.back_card_side_id,
              });
            }}
            loading={loadingCard?.id === card.id}
          />
        );
      })}
    </Fragment>
  );
};

CardGroupCardSelect.propTypes = propTypes;

export default CardGroupCardSelect;
